import { environment } from "@/environments/environment";

export const ourLeaders = [
  {
    name: "Nilesh Ranaware",
    designation: "Founder & CEO",
    message:
      "On a mission to make customization accessible to everyone, everywhere — through technology and innovation.",
    socials: {
      linkedin:
        "https://www.linkedin.com/in/nilesh-ranaware?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    image:
      "https://360customizer.s3.ap-south-1.amazonaws.com/designFiles/6.png",
  },
  {
    name: "Vikas Tiwari",
    designation: "Co-Founder & CTO",
    message:
      "Pioneering the future of corporate gifting and customization with solutions that never existed before.",
    socials: {
      linkedin:
        "https://www.linkedin.com/in/vikastiwari360?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    image:
      "https://360customizer.s3.ap-south-1.amazonaws.com/designFiles/7.png",
  },
];

export const ourTeam = [
  {
    id: 1,
    name: "Sasha Grey",
    position: "Design Lead",
    image: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/01eb2815-e965-4e24-8f44-2aae630f3945-WhatsApp Image 2025-09-17 at 22.56.29.jpeg`,
    linkedin: "https://linkedin.com/in/sashagrey",
  },
  {
    id: 2,
    name: "Nikita Xing",
    position: "Product Manager",
    image: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/01eb2815-e965-4e24-8f44-2aae630f3945-WhatsApp Image 2025-09-17 at 22.56.29.jpeg`,
    linkedin: "https://linkedin.com/in/nikitaxing",
  },
  {
    id: 3,
    name: "Anuj Mishra",
    position: "Creative Leader",
    image: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/01eb2815-e965-4e24-8f44-2aae630f3945-WhatsApp Image 2025-09-17 at 22.56.29.jpeg`,
    linkedin: "https://linkedin.com/in/anujmishra",
  },
  {
    id: 4,
    name: "Alexa Monic",
    position: "Marketing Head",
    image: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/01eb2815-e965-4e24-8f44-2aae630f3945-WhatsApp Image 2025-09-17 at 22.56.29.jpeg`,
    linkedin: "https://linkedin.com/in/alexamonic",
  },
];

export const ourCulture = [
  {
    id: 1,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/01eb2815-e965-4e24-8f44-2aae630f3945-WhatsApp Image 2025-09-17 at 22.56.29.jpeg`,
    alt: "Christmas Celebration",
  },
  {
    id: 2,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/12c06045-0bff-4271-8fc5-e9b665326e6d-WhatsApp Image 2025-09-17 at 22.56.29 (2).jpeg`,
    alt: "Team Lunch",
  },
  {
    id: 3,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/22681228-aeae-4f50-94cd-775b7fbe47d8-WhatsApp Image 2025-09-17 at 22.56.30 (6).jpeg`,
    alt: "Team Outing",
  },
  {
    id: 4,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/233349a6-eae2-47de-9975-e9fe8f941e5d-WhatsApp Image 2025-09-17 at 22.56.30 (10).jpeg`,
    alt: "Annual Day Championship",
  },
  {
    id: 5,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/29235d3b-dba2-454e-a387-d5c09acc59fb-WhatsApp Image 2025-09-17 at 22.56.30.jpeg`,
    alt: "Independence Day Celebration",
  },
  {
    id: 6,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/72d3bd24-026e-4303-867d-784f5ee92a39-WhatsApp Image 2025-09-17 at 22.56.30 (9).jpeg`,
    alt: "Gifting Event",
  },
  {
    id: 7,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/6e37499d-684d-4cf7-badc-ab2ce3220914-WhatsApp Image 2025-09-17 at 22.56.30 (7).jpeg`,
    alt: "Professional Day",
  },
  {
    id: 8,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/4f0fc1f6-b8a1-4bb0-a082-0bfa47149771-WhatsApp Image 2025-09-17 at 22.56.29 (5).jpeg`,
    alt: "Festival of Lights",
  },
  {
    id: 9,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/4271b797-35fc-41dc-a3e3-a0ffcb196998-IMG_1808.jpg`,
    alt: "Diwali Celebration",
  },
  {
    id: 10,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/3cf19422-5610-43b8-9089-aa40f01f4d02-WhatsApp Image 2025-09-17 at 22.56.29 (7).jpeg`,
    alt: "Championship Celebration",
  },
  {
    id: 11,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/73ad1cf0-2583-424e-bd8c-68e3154e8f28-WhatsApp Image 2025-09-17 at 22.56.29 (6).jpeg`,
    alt: "Cultural Day",
  },
  {
    id: 12,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/7d3799f1-b8a8-44b8-915a-673687d36237-IMG_0950.jpg`,
    alt: "Filmy Day",
  },
  {
    id: 13,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/88316007-27f1-4527-9e7a-d0a1d9b3bf83-WhatsApp Image 2025-09-17 at 22.56.30 (3).jpeg`,
    alt: "Dance Celebration - Women",
  },
  {
    id: 14,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/8b83f12a-5da7-48be-80e2-d971992c2662-IMG_0765.jpg`,
    alt: "CSR at Orphanage",
  },
  {
    id: 15,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/8bfef805-8ae3-4d4f-a506-e0af547cba4e-IMG_5915.jpg`,
    alt: "Women's Day",
  },
  {
    id: 16,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/de3b972f-2fba-46e3-954d-aa02b5b9b66b-WhatsApp Image 2025-09-17 at 22.56.30 (8).jpeg`,
    alt: "Annual Day Celebration",
  },
  {
    id: 17,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/9cc8a66c-7f4a-4102-8bb0-84a64f35a841-WhatsApp Image 2025-09-17 at 22.56.30 (4).jpeg`,
    alt: "Team Dinner",
  },
  {
    id: 18,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/999d43bb-7ceb-42ec-b7be-b27a841f0236-WhatsApp Image 2025-09-17 at 22.56.30 (5).jpeg`,
    alt: "Annual Day Championship Winner",
  },
  {
    id: 19,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/95a4058c-9f05-4c08-a850-68a131c75326-WhatsApp Image 2025-09-17 at 22.56.29 (1).jpeg`,
    alt: "Dance Celebration - Men",
  },
  {
    id: 20,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/925186da-59f4-4a64-b726-1ac10d326c82-WhatsApp Image 2025-09-17 at 22.56.30 (1).jpeg`,
    alt: "New Office Opening",
  },
  {
    id: 21,
    src: `https://360customizer.360customizer.com/${environment.S3_FOLDER_NAME}/360Official-Website/teamCultureImages/ec68ddc4-a5eb-46e4-9587-a01d73a1e763-WhatsApp Image 2025-09-17 at 22.56.30 (2).jpeg`,
    alt: "Ramp Walk",
  },
];

export const ourJourney = [
  {
    date: "2019",
    event: "Founded 360Customizer",
    info: "Started with a bold mission: revolutionize the custom merchandise industry.",
  },
  {
    date: "2020",
    event: "First 100 Clients",
    info: "Early believers turned into long-term partners. Product–market fit: confirmed.",
  },
  {
    date: "2021",
    event: "Team of 20+",
    info: "Built a high-ownership crew obsessed with quality, speed, and details.",
  },
  {
    date: "2022",
    event: "Office & Warehouse Expansion",
    info: "More space. More capacity. Faster turnarounds across larger volumes.",
  },
  {
    date: "2023",
    event: "Industry Recognition",
    info: "Named among premier corporate gifting companies by Silicon India.",
  },
  {
    date: "2024",
    event: "Tech Transformation Begins",
    info: "Scaling demanded automation. We appointed a CTO & Co-founder and built an in-house tech team to streamline operations and accelerate client delivery.",
  },
  {
    date: "2025",
    event: "Brandstore & AI Era",
    info: "Launched 360Brandstore and integrated AI across the company, lifting client productivity and cementing our tech-driven edge.",
  },
];
